<template>
    <div class="email-list">

        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>

        <!-- Email List -->
        <div v-else>
            <div v-if="emails.length > 0">
                <!-- Searchbar -->
                <div class="d-flex justify-content-between w-100 display">
                    <div class="d-flex gap-5 p-4 mt-2">
                        <!-- Tooltip for Envelope Icon -->
                        <span ref="envelopeIcon" style="cursor: pointer;" data-bs-toggle="tooltip"
                            data-bs-placement="top" title="Read Emails">
                            <EnvelopeOpenIcon class="h-5 w-5" @click="filterByReadStatus" />
                        </span>

                        <!-- Tooltip for Star Icon -->
                        <span ref="starIcon" style="cursor: pointer;" data-bs-toggle="tooltip" data-bs-placement="top"
                            title="Without Starred Emails">
                            <StarIcon class="h-5 w-5" @click="filterWithoutStarred" />
                        </span>

                        <!-- Tooltip for Star Icon (Starred Emails) -->
                        <span ref="starredIcon" style="cursor: pointer;" data-bs-toggle="tooltip"
                            data-bs-placement="top" title="Starred Emails">
                            <StarIcon class="h-5 w-5 text-warning" @click="filterByStarred" />
                        </span>

                        <!-- Tooltip for Settings Icon -->
                        <span ref="settingsIconWrapper" style="cursor: pointer; width: 22px; height: 22px;"
                            data-bs-toggle="tooltip" data-bs-placement="top" title="Settings" role="button">
                            <SettingIcon class="h-5 w-5" @click="openSettings" />
                        </span>
                    </div>

                    <div class="mt-1 d-flex" style="margin-right: 30px; position: relative;">
                        <!-- Input Field -->
                        <input type="text" v-model="searchQuery" @input="searchEmails"
                            class="form-control searchbar ps-5" placeholder="Search Email...."
                            style="padding-right: 40px;" />

                        <!-- Search Icon -->
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor"
                            style="width: 30px; height: 30px; position: absolute; top: 50%; right: 18px; transform: translateY(-50%); color: #666; cursor: pointer;">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                        </svg>


                    </div>
                </div>

                <hr>

                <!-- Email Items -->
                <div v-for="email in filteredEmails" :key="email.id"
                    class="email-item ms-3 d-flex justify-content-between align-items-center p-3 border-bottom display"
                    style="cursor: pointer;" @click="handleEmailClick(email)">
                    <div class="d-flex align-items-center">
                        <div class="d-flex gap-2">
                            <StarIcon style="cursor: pointer;" class="h-5 w-5 starIcon"
                                @click.stop="markAsStarred(email.id)" :class="email.is_starred ? 'text-warning' : ''" />
                        </div>

                        <div class="email-info ms-5 d-flex align-items-center text-truncate"
                            style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: calc(100vw - 200px);">
                            <!-- Add conditional styling for font weight -->
                            <strong :style="{ fontWeight: email.is_read ? 'normal' : 'bold' }">
                                {{ email.sender }}
                            </strong>
                            <span style="width: 600px;" class="text-muted"
                                :style="{ fontWeight: email.is_read ? 'normal' : 'bold', color: email.is_read ? 'black' : '' }">
                                - {{ truncateText(email.subject, 50) }}
                            </span>
                            <!-- <span class="text-muted text-truncate" style="margin-left: 5px;">
                                {{ email.snippet }}
                            </span> -->
                            <p class="mt-2" style="font-size: 13px; margin-left: 110px;">{{ formatTime(email.created_at) }}</p>
                        </div>
                    </div>

                    <!-- <div class="email-actions d-flex align-items-center">
                        <span ref="eyeIcon" title="Show">
                            <EyeIcon style="cursor: pointer;" class="h-5 w-5 mx-2"
                                @click="$router.push({ name: 'EmailDetails', params: { id: email.id } })" />
                        </span>
                        <span ref="markAsReadIcon" title="Mark As Read">
                            <EnvelopeIcon style="cursor: pointer;" class="h-5 w-5 mx-2"
                                :class="email.is_read ? 'text-warning' : ''" @click.stop="markAsRead(email.id)" />
                        </span>
                        <span ref="trashIcon" title="Move to trash">
                            <TrashIcon style="cursor: pointer;" class="h-5 w-5 mx-2"
                                @click.stop="moveToTrash(email.id)" />
                        </span>
                        <span ref="archiveIcon" title="Move to Archive">
                            <ArchiveBoxIcon style="cursor: pointer;" class="h-5 w-5 mx-2"
                                @click.stop="moveToArchive(email.id)" />
                        </span>
                    </div> -->
                    
                </div>



            </div>
            <div v-else class="my-5 text-center">
                <h3>No Emails</h3>
            </div>

        </div>

    </div>
</template>

<script>
import axios from 'axios';
import { apiUrl } from '@/globalVariable';
import {  EnvelopeOpenIcon, StarIcon, Cog6ToothIcon as SettingIcon } from '@heroicons/vue/24/outline';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';


export default {
    components: {
      
        StarIcon,
        EnvelopeOpenIcon,

        SettingIcon
    },
    data() {
        return {
            emails: [],
            loading: true,
            filteredEmails: [],
            searchQuery: '',
            isReadFiltered: null,
            isStarredFiltered: null,
            isNotStarredFiltered: null,
        };
    },
    created() {
        this.filteredEmails = this.emails;
    },

    mounted() {
        this.getEmail();
    },

    // beforeUnmount() { 
    //     if (this.interval) {
    //         clearInterval(this.interval);
    //     }
    // },


    methods: {

        async getEmail() {
            try {
                this.loading = true;

                // Fetch emails
                const response = await axios.get(`${apiUrl}emails`);
                this.emails = response.data.email;
                this.filteredEmails = this.emails;

                // Fetch errors
                // const errorResponse = await axios.get(`${apiUrl}email-errors`);
                // const errors = errorResponse.data;


                // Show errors using Toastr
                // if (errors.length > 0) {
                //     errors.forEach(error => {
                //         toastr.error(`${error.email}: ${error.message}`, 'Email Fetching Error');
                //     });
                // }
            } catch (error) {
                toastr.error('Failed to fetch emails.', 'Error');
            } finally {
                this.loading = false;
            }
        },


        async markAsRead(email) {
            try {
                if (!email.is_read) {
                    await axios.patch(`${apiUrl}emails/${email}/read`);
                    toastr.success('Successfully Read Email');
                    this.getEmail();
                }
            } catch (error) {
                console.error('Error marking email as read:', error);
            }
        },


        async handleEmailClick(email) {
            try {
                if (!email.is_read) {
                    await axios.patch(`${apiUrl}emails/${email.id}/read`);
                }
                this.$router.push({ name: 'EmailDetails', params: { id: email.id } });
            } catch (error) {
                console.error('Error marking email as read:', error);
            }
        },

        async markAsStarred(email) {
            try {

                if (!email.is_starred) {
                    await axios.patch(`${apiUrl}emails/${email}/star`);
                    toastr.success('Successfully Starred Email');
                    this.getEmail();
                }
            } catch (error) {
                console.error('Error marking email as starred:', error);
            }
        },

        searchEmails() {
            if (this.searchQuery.trim() === '') {
                this.filteredEmails = this.emails;
            } else {
                this.filteredEmails = this.emails.filter(email =>
                    email.subject.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    email.snippet.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    email.sender.toLowerCase().includes(this.searchQuery.toLowerCase())
                );
            }
        },

        openSettings() {
            this.$router.push('/config-index');
        },

        async moveToTrash(emailId) {
            try {
                await axios.patch(`${apiUrl}emails/${emailId}/trash`);
                toastr.success('Successfully Email Move to Trash.');
                this.getEmail();
            } catch (error) {
                console.error('Error moving email to trash:', error);
            }
        },

        async moveToArchive(emailId) {
            try {
                await axios.patch(`${apiUrl}emails/${emailId}/archive`);
                toastr.success('Successfully Email move to Archive.');
                this.getEmail();
            } catch (error) {
                console.error('Error moving email to archive:', error);
            }
        },


        filterByReadStatus() {

            if (this.isReadFiltered === null || this.isReadFiltered === 0) {
                this.isReadFiltered = 1;
                this.isStarredFiltered = null;
                this.isNotStarredFiltered = null;
            } else {
                this.isReadFiltered = null;
            }
            this.applyFilters();
        },


        filterByStarred() {

            if (this.isStarredFiltered === null || this.isStarredFiltered === 0) {
                this.isStarredFiltered = 1;
                this.isNotStarredFiltered = null;
                this.isReadFiltered = null;
            } else {
                this.isStarredFiltered = null;
            }
            this.applyFilters();
        },


        filterWithoutStarred() {

            if (this.isNotStarredFiltered === null || this.isNotStarredFiltered === 1) {
                this.isNotStarredFiltered = 0;
                this.isStarredFiltered = null;
                this.isReadFiltered = null;
            } else {
                this.isNotStarredFiltered = null;
            }
            this.applyFilters();
        },


        applyFilters() {
            let filtered = this.emails;


            if (this.isReadFiltered !== null) {
                filtered = filtered.filter(email => email.is_read === this.isReadFiltered);
            }


            if (this.isStarredFiltered !== null) {
                filtered = filtered.filter(email => email.is_starred === this.isStarredFiltered);
            }


            if (this.isNotStarredFiltered !== null) {
                filtered = filtered.filter(email => email.is_starred === this.isNotStarredFiltered);
            }


            this.filteredEmails = filtered;
        },
        formatTime(timestamp) {
            const date = new Date(timestamp);
            const formattedDate = new Intl.DateTimeFormat('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
            }).format(date);

            // const now = new Date();
            // const diffInMs = now - date;
            // const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

            return `${formattedDate}`;
        },

        truncateText(text, maxLength) {
            if (!text) return "";
            return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
        },


    }
};
</script>

<style scoped>
.searchbar {
    margin: 10px;
    width: 100%;
    border: 1px solid #0CAF60;
    border-radius: 10px;
    padding: 13px;
}

.email-list {
    flex: 1;
}

.loader-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 1000;
}

.loader {
    border: 4px solid #a4d4a3;
    border-top: 4px solid #0CAF60;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

.tooltip {
    z-index: 1050 !important;
}


@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.email-item:hover {
    background-color: #f1f1f1;
}
.email-item{
    height: 50px;
}

.h-5 {
    height: 1.25rem;
}

.w-5 {
    width: 1.25rem;
}

.starIcon {
    margin-top: 3px;
    margin-left: 10px;
}


@media (max-width: 698px) and (min-width: 500px) {
    .display {
        display: flex;
        flex-direction: column;
    }

    .starIcon {
        margin-top: 20px;
    }
}

@media (max-width: 500px) {
    .display {
        display: flex;
        flex-direction: column;
    }

    .starIcon {
        margin-top: 37px;
    }
}
</style>
